import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import LoadingIndicator from 'shared/components/loading-indicator/loading-indicator';
import { DeviceDetailsProvider } from 'shared/providers/device-details/providers/device-details-provider';

import DeviceDetailsPopup from 'features/device/device-details/views/device-details-popup.component';
import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import { useIS32ContextProvider } from 'features/systems/IS32/context/IS32-provider';
import { IS32DetailsProvider } from 'features/systems/IS32/providers/IS32-details.provider';
import styles from 'features/systems/IS32/views/IS32-configuration.module.scss';
import IS32ConfigurationAccordionItem from './IS32-configuration-accordion-item';

const IS32Configuration = () => {
  const { t } = useTranslation('IS32');
  const { readIS32ConfigurationIsLoading, readIS32ConfigurationData, selectedDeviceId } = useIS32ContextProvider();

  const {
    systemsDetailsHook: { refreshSystem },
  } = useSystemsContextProvider();

  return (
    <div className={styles.configurationContainer}>
      {readIS32ConfigurationIsLoading && <LoadingIndicator />}
      <Typography variant="h5" className={styles.title}>
        {t('title')}
      </Typography>
      {!readIS32ConfigurationIsLoading &&
        readIS32ConfigurationData?.units &&
        [...(readIS32ConfigurationData?.units ?? [])]
          .sort((unitA, unitB) => Number(unitA.address) - Number(unitB.address))
          .map((unit) => {
            return (
              <IS32DetailsProvider key={unit.address} unit={unit}>
                <IS32ConfigurationAccordionItem unit={unit} />
              </IS32DetailsProvider>
            );
          })}
      {selectedDeviceId && (
        <DeviceDetailsProvider deviceId={selectedDeviceId} initialViewingMode={'viewing'}>
          <DeviceDetailsPopup onCloseCallback={() => refreshSystem()} />
        </DeviceDetailsProvider>
      )}
    </div>
  );
};

export default IS32Configuration;
